import PropTypes from "prop-types";
import styles from "./index.css";
import getProductLink from "./getProductLink";
import Fulfilment from "../Fulfilment";
import ProductHero from "../ProductHero";
import ProductTitle from "../ProductTitle";
import getAriaLabelledBy from "./getAriaLabelledBy";

const ProductTile = ({
  ProductTileControls,
  ProductPriceComponents,
  ProductTileBadges = () => null,
  productId,
  title,
  variantId,
  ctaRef,
  isForceDisabled,
  source,
  seller,
  ...rest
}) => {
  const labels = getAriaLabelledBy({ productId, variantId });

  return (
    <div className={styles.productTile} aria-hidden={isForceDisabled}>
      <div className={styles.nonControls}>
        <a
          aria-labelledby={labels.labelledBy}
          href={getProductLink({ variantId, productId, ctaRef })}
        >
          <ProductHero {...{ variantId, labels, ...rest }} />
          <ProductTitle labelledById={labels.title} title={title} />
          <ProductPriceComponents
            labelledById={labels.price}
            discountLabelledById={labels.discount}
            variantId={variantId}
            {...rest}
          />
        </a>
        <ProductTileBadges {...{ ...labels, ...rest }} />
        <Fulfilment
          labelledById={labels.fulfilment}
          source={source}
          seller={seller}
          productId={productId}
          variantId={variantId}
        />
      </div>
      <ProductTileControls
        productId={productId}
        variantId={variantId}
        isForceDisabled={isForceDisabled}
        seller={seller}
        source={source}
        title={title}
        {...rest}
      />
    </div>
  );
};

ProductTile.propTypes = {
  ProductTileControls: PropTypes.elementType.isRequired,
  ProductPriceComponents: PropTypes.elementType.isRequired,
  ProductTileBadges: PropTypes.elementType,
  productId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  variantId: PropTypes.number,
  ctaRef: PropTypes.string.isRequired,
  isForceDisabled: PropTypes.bool.isRequired,
  source: PropTypes.shape({
    description: PropTypes.string.isRequired
  }),
  seller: PropTypes.shape({
    description: PropTypes.string.isRequired
  })
};

export default ProductTile;
